import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  Upload: File;
  _Any: any;
  federation__FieldSet: any;
  link__Import: any;
};

export type AdminSearchMessagesInput = {
  /** 검색 종료 날짜 (ISO 8601 형식) */
  endDate?: InputMaybe<Scalars['String']>;
  /** 검색어 (메시지 내용) */
  query?: InputMaybe<Scalars['String']>;
  /** 메시지 역할 필터 (USER 또는 ASSISTANT) */
  role?: InputMaybe<Scalars['String']>;
  /** 검색 시작 날짜 (ISO 8601 형식) */
  startDate?: InputMaybe<Scalars['String']>;
  /** 사용자 ID 필터 (특정 사용자의 메시지만 검색) */
  userId?: InputMaybe<Scalars['String']>;
};

export type AdminSearchSessionsInput = {
  /** 검색 종료 날짜 (ISO 8601 형식) */
  endDate?: InputMaybe<Scalars['String']>;
  /** 검색어 (세션 제목 및 메시지 내용 포함) */
  query?: InputMaybe<Scalars['String']>;
  /** 검색 시작 날짜 (ISO 8601 형식) */
  startDate?: InputMaybe<Scalars['String']>;
  /** 사용자 ID 필터 (특정 사용자의 세션만 검색) */
  userId?: InputMaybe<Scalars['String']>;
};

export type Chunk = {
  __typename?: 'Chunk';
  chunkIndex: Scalars['Int'];
  content: Scalars['String'];
  createdAt: Scalars['DateTime'];
  documentId: Scalars['ID'];
  embedding?: Maybe<Array<Scalars['Float']>>;
  embeddingModel?: Maybe<Scalars['String']>;
  embeddingProvider?: Maybe<Scalars['String']>;
  endOffset: Scalars['Int'];
  id: Scalars['ID'];
  metadata?: Maybe<Scalars['String']>;
  nextChunkId?: Maybe<Scalars['ID']>;
  previousChunkId?: Maybe<Scalars['ID']>;
  startOffset: Scalars['Int'];
  tokenCount?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChunkList = {
  __typename?: 'ChunkList';
  chunks: Array<Chunk>;
  limit: Scalars['Int'];
  page: Scalars['Int'];
  total: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type CreateSessionInput = {
  title?: InputMaybe<Scalars['String']>;
};

export type Document = {
  __typename?: 'Document';
  chunks?: Maybe<ChunkList>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  extractionStatus?: Maybe<ExtractionStatus>;
  filename: Scalars['String'];
  firstChunk?: Maybe<Chunk>;
  id: Scalars['ID'];
  metadata?: Maybe<Scalars['String']>;
  mimeType: Scalars['String'];
  originalFilename: Scalars['String'];
  sizeInBytes: Scalars['Int'];
  status: Scalars['String'];
  storagePath: Scalars['String'];
  uploadedAt: Scalars['DateTime'];
  uploadedBy: Scalars['String'];
};


export type DocumentChunksArgs = {
  input?: InputMaybe<ListChunksInput>;
};

export type DocumentList = {
  __typename?: 'DocumentList';
  documents: Array<Document>;
  limit: Scalars['Int'];
  page: Scalars['Int'];
  total: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type ExtractionStatus = {
  __typename?: 'ExtractionStatus';
  chunksWithEmbeddings: Scalars['Int'];
  completedAt?: Maybe<Scalars['DateTime']>;
  completionPercentage: Scalars['Float'];
  documentFilename: Scalars['String'];
  documentId: Scalars['ID'];
  error?: Maybe<Scalars['String']>;
  extractedText?: Maybe<Scalars['String']>;
  processingStatus: Scalars['String'];
  startedAt: Scalars['DateTime'];
  textLength?: Maybe<Scalars['Int']>;
  totalChunks: Scalars['Int'];
};

export type ListChunksInput = {
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
};

export type ListDocumentsInput = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  uploadedBy?: InputMaybe<Scalars['String']>;
};

export type Message = {
  __typename?: 'Message';
  content: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  parentMessageId?: Maybe<Scalars['ID']>;
  role: Scalars['String'];
  sequenceNumber: Scalars['Int'];
  sessionId: Scalars['ID'];
  tokenCount: Scalars['Int'];
};

export type MessageConnection = {
  __typename?: 'MessageConnection';
  /** 메시지 엣지 목록 */
  edges: Array<MessageEdge>;
  /** 페이지 정보 */
  pageInfo: PageInfo;
  /** 전체 검색 결과 수 */
  totalCount: Scalars['Int'];
};

export type MessageEdge = {
  __typename?: 'MessageEdge';
  /** 커서 */
  cursor: Scalars['String'];
  /** 메시지 노드 */
  node: Message;
  /** 메시지가 속한 세션 ID (검색 결과 컨텍스트) */
  sessionId: Scalars['String'];
  /** 메시지가 속한 세션 제목 */
  sessionTitle?: Maybe<Scalars['String']>;
  /** 메시지가 속한 세션의 사용자 ID (어드민 검색용) */
  sessionUserId: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  createSession: Session;
  deleteDocument: Scalars['Boolean'];
  deleteMessage: Scalars['Boolean'];
  deleteSession: Scalars['Boolean'];
  sendMessage: SendMessageResult;
  uploadDocument: Document;
};


export type MutationCreateSessionArgs = {
  input: CreateSessionInput;
};


export type MutationDeleteDocumentArgs = {
  id: Scalars['String'];
};


export type MutationDeleteMessageArgs = {
  messageId: Scalars['ID'];
  sessionId: Scalars['ID'];
};


export type MutationDeleteSessionArgs = {
  sessionId: Scalars['ID'];
};


export type MutationSendMessageArgs = {
  input: SendMessageInput;
};


export type MutationUploadDocumentArgs = {
  input: UploadDocumentInput;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  /** 끝 커서 */
  endCursor?: Maybe<Scalars['String']>;
  /** 다음 페이지 존재 여부 */
  hasNextPage: Scalars['Boolean'];
  /** 이전 페이지 존재 여부 */
  hasPreviousPage: Scalars['Boolean'];
  /** 시작 커서 */
  startCursor?: Maybe<Scalars['String']>;
};

export type PaginationInput = {
  /** 이 커서 이후의 항목들을 가져옴 */
  after?: InputMaybe<Scalars['String']>;
  /** 가져올 항목 수 (기본: 20, 최대: 100) */
  first?: InputMaybe<Scalars['Int']>;
};

export type Query = {
  __typename?: 'Query';
  _entities: Array<Maybe<_Entity>>;
  _service: _Service;
  /** 어드민 전용: 전체 사용자 메시지 검색 (페이징 지원) */
  adminSearchMessages: MessageConnection;
  /** 어드민 전용: 전체 사용자 세션 검색 (페이징 지원) */
  adminSearchSessions: SessionConnection;
  chunk: Chunk;
  chunks: ChunkList;
  document: Document;
  documents: DocumentList;
  extractionStatus: ExtractionStatus;
  messages: Array<Message>;
  mySessions: Array<Session>;
  /** 메시지 검색 (페이징 지원) */
  searchMessages: MessageConnection;
  /** 세션 검색 (페이징 지원) */
  searchSessions: SessionConnection;
  session?: Maybe<Session>;
};


export type Query_EntitiesArgs = {
  representations: Array<Scalars['_Any']>;
};


export type QueryAdminSearchMessagesArgs = {
  filter?: InputMaybe<AdminSearchMessagesInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryAdminSearchSessionsArgs = {
  filter?: InputMaybe<AdminSearchSessionsInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryChunkArgs = {
  chunkId: Scalars['String'];
};


export type QueryChunksArgs = {
  documentId: Scalars['String'];
  input?: InputMaybe<ListChunksInput>;
};


export type QueryDocumentArgs = {
  id: Scalars['String'];
};


export type QueryDocumentsArgs = {
  input?: InputMaybe<ListDocumentsInput>;
};


export type QueryExtractionStatusArgs = {
  documentId: Scalars['String'];
};


export type QueryMessagesArgs = {
  sessionId: Scalars['ID'];
};


export type QuerySearchMessagesArgs = {
  filter?: InputMaybe<SearchMessagesInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QuerySearchSessionsArgs = {
  filter?: InputMaybe<SearchSessionsInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QuerySessionArgs = {
  sessionId: Scalars['ID'];
};

export type SearchMessagesInput = {
  /** 검색 종료 날짜 (ISO 8601 형식) */
  endDate?: InputMaybe<Scalars['String']>;
  /** 검색어 (메시지 내용) */
  query?: InputMaybe<Scalars['String']>;
  /** 메시지 역할 필터 (USER 또는 ASSISTANT) */
  role?: InputMaybe<Scalars['String']>;
  /** 검색 시작 날짜 (ISO 8601 형식) */
  startDate?: InputMaybe<Scalars['String']>;
};

export type SearchSessionsInput = {
  /** 검색 종료 날짜 (ISO 8601 형식) */
  endDate?: InputMaybe<Scalars['String']>;
  /** 검색어 (세션 제목 및 메시지 내용 포함) */
  query?: InputMaybe<Scalars['String']>;
  /** 검색 시작 날짜 (ISO 8601 형식) */
  startDate?: InputMaybe<Scalars['String']>;
};

export type SendMessageInput = {
  content: Scalars['String'];
  sessionId: Scalars['ID'];
};

export type SendMessageResult = {
  __typename?: 'SendMessageResult';
  assistantMessage: Message;
  userMessage: Message;
};

export type Session = {
  __typename?: 'Session';
  contextWindowTokens: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  messageCount: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
};

export type SessionConnection = {
  __typename?: 'SessionConnection';
  /** 세션 엣지 목록 */
  edges: Array<SessionEdge>;
  /** 페이지 정보 */
  pageInfo: PageInfo;
  /** 전체 검색 결과 수 */
  totalCount: Scalars['Int'];
};

export type SessionEdge = {
  __typename?: 'SessionEdge';
  /** 커서 */
  cursor: Scalars['String'];
  /** 세션 노드 */
  node: Session;
};

export type Subscription = {
  __typename?: 'Subscription';
  extractionStatusUpdated: ExtractionStatus;
};

export type UploadDocumentInput = {
  file: Scalars['Upload'];
  metadata?: InputMaybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  id: Scalars['ID'];
  sessions?: Maybe<Array<Session>>;
};

export type _Entity = Document | Session | User;

export type _Service = {
  __typename?: '_Service';
  sdl?: Maybe<Scalars['String']>;
};

export enum Link__Purpose {
  /** `EXECUTION` features provide metadata necessary for operation execution. */
  Execution = 'EXECUTION',
  /** `SECURITY` features provide metadata necessary to securely resolve fields. */
  Security = 'SECURITY'
}

export type InfohubGetDocumentsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  uploadedBy?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['String']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
}>;


export type InfohubGetDocumentsQuery = { __typename?: 'Query', documents: { __typename?: 'DocumentList', total: number, page: number, limit: number, totalPages: number, documents: Array<{ __typename?: 'Document', id: string, filename: string, originalFilename: string, mimeType: string, sizeInBytes: number, storagePath: string, status: string, uploadedBy: string, uploadedAt: any, deletedAt?: any | null, metadata?: string | null, extractionStatus?: { __typename?: 'ExtractionStatus', documentId: string, documentFilename: string, processingStatus: string, totalChunks: number, chunksWithEmbeddings: number, completionPercentage: number, extractedText?: string | null, textLength?: number | null, error?: string | null, startedAt: any, completedAt?: any | null } | null }> } };

export type InfohubGetDocumentQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type InfohubGetDocumentQuery = { __typename?: 'Query', document: { __typename?: 'Document', id: string, filename: string, originalFilename: string, mimeType: string, sizeInBytes: number, storagePath: string, status: string, uploadedBy: string, uploadedAt: any, deletedAt?: any | null, metadata?: string | null, extractionStatus?: { __typename?: 'ExtractionStatus', documentId: string, documentFilename: string, processingStatus: string, totalChunks: number, chunksWithEmbeddings: number, completionPercentage: number, extractedText?: string | null, textLength?: number | null, error?: string | null, startedAt: any, completedAt?: any | null } | null } };

export type InfohubGetExtractionStatusQueryVariables = Exact<{
  documentId: Scalars['String'];
}>;


export type InfohubGetExtractionStatusQuery = { __typename?: 'Query', extractionStatus: { __typename?: 'ExtractionStatus', documentId: string, documentFilename: string, processingStatus: string, totalChunks: number, chunksWithEmbeddings: number, completionPercentage: number, extractedText?: string | null, textLength?: number | null, error?: string | null, startedAt: any, completedAt?: any | null } };

export type InfohubGetDocumentChunksQueryVariables = Exact<{
  documentId: Scalars['String'];
  page?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['String']>;
}>;


export type InfohubGetDocumentChunksQuery = { __typename?: 'Query', chunks: { __typename?: 'ChunkList', total: number, page: number, limit: number, totalPages: number, chunks: Array<{ __typename?: 'Chunk', id: string, documentId: string, content: string, chunkIndex: number, startOffset: number, endOffset: number, tokenCount?: number | null, embedding?: Array<number> | null, embeddingProvider?: string | null, embeddingModel?: string | null, metadata?: string | null, previousChunkId?: string | null, nextChunkId?: string | null, createdAt: any, updatedAt?: any | null }> } };

export type InfohubGetChunkQueryVariables = Exact<{
  chunkId: Scalars['String'];
}>;


export type InfohubGetChunkQuery = { __typename?: 'Query', chunk: { __typename?: 'Chunk', id: string, documentId: string, content: string, chunkIndex: number, startOffset: number, endOffset: number, tokenCount?: number | null, embedding?: Array<number> | null, embeddingProvider?: string | null, embeddingModel?: string | null, metadata?: string | null, previousChunkId?: string | null, nextChunkId?: string | null, createdAt: any, updatedAt?: any | null } };

export type InfohubUploadDocumentMutationVariables = Exact<{
  file: Scalars['Upload'];
  metadata?: InputMaybe<Scalars['String']>;
}>;


export type InfohubUploadDocumentMutation = { __typename?: 'Mutation', uploadDocument: { __typename?: 'Document', id: string, filename: string, originalFilename: string, mimeType: string, sizeInBytes: number, storagePath: string, status: string, uploadedBy: string, uploadedAt: any, metadata?: string | null } };

export type InfohubDeleteDocumentMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type InfohubDeleteDocumentMutation = { __typename?: 'Mutation', deleteDocument: boolean };

export type InfohubCreateSessionMutationVariables = Exact<{
  title?: InputMaybe<Scalars['String']>;
}>;


export type InfohubCreateSessionMutation = { __typename?: 'Mutation', createSession: { __typename?: 'Session', id: string, userId: string, title?: string | null, messageCount: number, createdAt: any, lastMessageAt?: any | null, contextWindowTokens: number } };

export type InfohubSendMessageMutationVariables = Exact<{
  sessionId: Scalars['ID'];
  content: Scalars['String'];
}>;


export type InfohubSendMessageMutation = { __typename?: 'Mutation', sendMessage: { __typename?: 'SendMessageResult', userMessage: { __typename?: 'Message', id: string, sessionId: string, role: string, content: string, tokenCount: number, sequenceNumber: number, createdAt: any, parentMessageId?: string | null }, assistantMessage: { __typename?: 'Message', id: string, sessionId: string, role: string, content: string, tokenCount: number, sequenceNumber: number, createdAt: any, parentMessageId?: string | null } } };

export type InfohubGetMySessionsQueryVariables = Exact<{ [key: string]: never; }>;


export type InfohubGetMySessionsQuery = { __typename?: 'Query', mySessions: Array<{ __typename?: 'Session', id: string, userId: string, title?: string | null, messageCount: number, createdAt: any, lastMessageAt?: any | null, contextWindowTokens: number }> };

export type InfohubGetSessionQueryVariables = Exact<{
  sessionId: Scalars['ID'];
}>;


export type InfohubGetSessionQuery = { __typename?: 'Query', session?: { __typename?: 'Session', id: string, userId: string, title?: string | null, messageCount: number, createdAt: any, lastMessageAt?: any | null, contextWindowTokens: number } | null };

export type InfohubGetSessionMessagesQueryVariables = Exact<{
  sessionId: Scalars['ID'];
}>;


export type InfohubGetSessionMessagesQuery = { __typename?: 'Query', messages: Array<{ __typename?: 'Message', id: string, sessionId: string, role: string, content: string, tokenCount: number, sequenceNumber: number, createdAt: any, parentMessageId?: string | null }> };

export type InfohubDeleteSessionMutationVariables = Exact<{
  sessionId: Scalars['ID'];
}>;


export type InfohubDeleteSessionMutation = { __typename?: 'Mutation', deleteSession: boolean };

export type InfohubDeleteMessageMutationVariables = Exact<{
  sessionId: Scalars['ID'];
  messageId: Scalars['ID'];
}>;


export type InfohubDeleteMessageMutation = { __typename?: 'Mutation', deleteMessage: boolean };

export type InfohubSubscribeExtractionStatusSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type InfohubSubscribeExtractionStatusSubscription = { __typename?: 'Subscription', extractionStatusUpdated: { __typename?: 'ExtractionStatus', documentId: string, documentFilename: string, processingStatus: string, totalChunks: number, chunksWithEmbeddings: number, completionPercentage: number, extractedText?: string | null, textLength?: number | null, error?: string | null, startedAt: any, completedAt?: any | null } };

export type InfohubAdminSearchSessionsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type InfohubAdminSearchSessionsQuery = { __typename?: 'Query', adminSearchSessions: { __typename?: 'SessionConnection', totalCount: number, edges: Array<{ __typename?: 'SessionEdge', cursor: string, node: { __typename?: 'Session', id: string, userId: string, title?: string | null, messageCount: number, createdAt: any, lastMessageAt?: any | null, contextWindowTokens: number } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type InfohubAdminSearchMessagesQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type InfohubAdminSearchMessagesQuery = { __typename?: 'Query', adminSearchMessages: { __typename?: 'MessageConnection', totalCount: number, edges: Array<{ __typename?: 'MessageEdge', cursor: string, sessionId: string, sessionUserId: string, sessionTitle?: string | null, node: { __typename?: 'Message', id: string, sessionId: string, role: string, content: string, tokenCount: number, sequenceNumber: number, createdAt: any, parentMessageId?: string | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };


export const InfohubGetDocumentsDocument = gql`
    query InfohubGetDocuments($page: Int, $limit: Int, $uploadedBy: String, $orderBy: String, $order: String, $includeDeleted: Boolean) {
  documents(
    input: {page: $page, limit: $limit, uploadedBy: $uploadedBy, orderBy: $orderBy, order: $order, includeDeleted: $includeDeleted}
  ) {
    documents {
      id
      filename
      originalFilename
      mimeType
      sizeInBytes
      storagePath
      status
      uploadedBy
      uploadedAt
      deletedAt
      metadata
      extractionStatus {
        documentId
        documentFilename
        processingStatus
        totalChunks
        chunksWithEmbeddings
        completionPercentage
        extractedText
        textLength
        error
        startedAt
        completedAt
      }
    }
    total
    page
    limit
    totalPages
  }
}
    `;

/**
 * __useInfohubGetDocumentsQuery__
 *
 * To run a query within a React component, call `useInfohubGetDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfohubGetDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfohubGetDocumentsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      uploadedBy: // value for 'uploadedBy'
 *      orderBy: // value for 'orderBy'
 *      order: // value for 'order'
 *      includeDeleted: // value for 'includeDeleted'
 *   },
 * });
 */
export function useInfohubGetDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<InfohubGetDocumentsQuery, InfohubGetDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InfohubGetDocumentsQuery, InfohubGetDocumentsQueryVariables>(InfohubGetDocumentsDocument, options);
      }
export function useInfohubGetDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InfohubGetDocumentsQuery, InfohubGetDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InfohubGetDocumentsQuery, InfohubGetDocumentsQueryVariables>(InfohubGetDocumentsDocument, options);
        }
export type InfohubGetDocumentsQueryHookResult = ReturnType<typeof useInfohubGetDocumentsQuery>;
export type InfohubGetDocumentsLazyQueryHookResult = ReturnType<typeof useInfohubGetDocumentsLazyQuery>;
export type InfohubGetDocumentsQueryResult = Apollo.QueryResult<InfohubGetDocumentsQuery, InfohubGetDocumentsQueryVariables>;
export const InfohubGetDocumentDocument = gql`
    query InfohubGetDocument($id: String!) {
  document(id: $id) {
    id
    filename
    originalFilename
    mimeType
    sizeInBytes
    storagePath
    status
    uploadedBy
    uploadedAt
    deletedAt
    metadata
    extractionStatus {
      documentId
      documentFilename
      processingStatus
      totalChunks
      chunksWithEmbeddings
      completionPercentage
      extractedText
      textLength
      error
      startedAt
      completedAt
    }
  }
}
    `;

/**
 * __useInfohubGetDocumentQuery__
 *
 * To run a query within a React component, call `useInfohubGetDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfohubGetDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfohubGetDocumentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInfohubGetDocumentQuery(baseOptions: Apollo.QueryHookOptions<InfohubGetDocumentQuery, InfohubGetDocumentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InfohubGetDocumentQuery, InfohubGetDocumentQueryVariables>(InfohubGetDocumentDocument, options);
      }
export function useInfohubGetDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InfohubGetDocumentQuery, InfohubGetDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InfohubGetDocumentQuery, InfohubGetDocumentQueryVariables>(InfohubGetDocumentDocument, options);
        }
export type InfohubGetDocumentQueryHookResult = ReturnType<typeof useInfohubGetDocumentQuery>;
export type InfohubGetDocumentLazyQueryHookResult = ReturnType<typeof useInfohubGetDocumentLazyQuery>;
export type InfohubGetDocumentQueryResult = Apollo.QueryResult<InfohubGetDocumentQuery, InfohubGetDocumentQueryVariables>;
export const InfohubGetExtractionStatusDocument = gql`
    query InfohubGetExtractionStatus($documentId: String!) {
  extractionStatus(documentId: $documentId) {
    documentId
    documentFilename
    processingStatus
    totalChunks
    chunksWithEmbeddings
    completionPercentage
    extractedText
    textLength
    error
    startedAt
    completedAt
  }
}
    `;

/**
 * __useInfohubGetExtractionStatusQuery__
 *
 * To run a query within a React component, call `useInfohubGetExtractionStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfohubGetExtractionStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfohubGetExtractionStatusQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useInfohubGetExtractionStatusQuery(baseOptions: Apollo.QueryHookOptions<InfohubGetExtractionStatusQuery, InfohubGetExtractionStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InfohubGetExtractionStatusQuery, InfohubGetExtractionStatusQueryVariables>(InfohubGetExtractionStatusDocument, options);
      }
export function useInfohubGetExtractionStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InfohubGetExtractionStatusQuery, InfohubGetExtractionStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InfohubGetExtractionStatusQuery, InfohubGetExtractionStatusQueryVariables>(InfohubGetExtractionStatusDocument, options);
        }
export type InfohubGetExtractionStatusQueryHookResult = ReturnType<typeof useInfohubGetExtractionStatusQuery>;
export type InfohubGetExtractionStatusLazyQueryHookResult = ReturnType<typeof useInfohubGetExtractionStatusLazyQuery>;
export type InfohubGetExtractionStatusQueryResult = Apollo.QueryResult<InfohubGetExtractionStatusQuery, InfohubGetExtractionStatusQueryVariables>;
export const InfohubGetDocumentChunksDocument = gql`
    query InfohubGetDocumentChunks($documentId: String!, $page: Int, $limit: Int, $orderBy: String, $order: String) {
  chunks(
    documentId: $documentId
    input: {page: $page, limit: $limit, orderBy: $orderBy, order: $order}
  ) {
    chunks {
      id
      documentId
      content
      chunkIndex
      startOffset
      endOffset
      tokenCount
      embedding
      embeddingProvider
      embeddingModel
      metadata
      previousChunkId
      nextChunkId
      createdAt
      updatedAt
    }
    total
    page
    limit
    totalPages
  }
}
    `;

/**
 * __useInfohubGetDocumentChunksQuery__
 *
 * To run a query within a React component, call `useInfohubGetDocumentChunksQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfohubGetDocumentChunksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfohubGetDocumentChunksQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      orderBy: // value for 'orderBy'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useInfohubGetDocumentChunksQuery(baseOptions: Apollo.QueryHookOptions<InfohubGetDocumentChunksQuery, InfohubGetDocumentChunksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InfohubGetDocumentChunksQuery, InfohubGetDocumentChunksQueryVariables>(InfohubGetDocumentChunksDocument, options);
      }
export function useInfohubGetDocumentChunksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InfohubGetDocumentChunksQuery, InfohubGetDocumentChunksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InfohubGetDocumentChunksQuery, InfohubGetDocumentChunksQueryVariables>(InfohubGetDocumentChunksDocument, options);
        }
export type InfohubGetDocumentChunksQueryHookResult = ReturnType<typeof useInfohubGetDocumentChunksQuery>;
export type InfohubGetDocumentChunksLazyQueryHookResult = ReturnType<typeof useInfohubGetDocumentChunksLazyQuery>;
export type InfohubGetDocumentChunksQueryResult = Apollo.QueryResult<InfohubGetDocumentChunksQuery, InfohubGetDocumentChunksQueryVariables>;
export const InfohubGetChunkDocument = gql`
    query InfohubGetChunk($chunkId: String!) {
  chunk(chunkId: $chunkId) {
    id
    documentId
    content
    chunkIndex
    startOffset
    endOffset
    tokenCount
    embedding
    embeddingProvider
    embeddingModel
    metadata
    previousChunkId
    nextChunkId
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useInfohubGetChunkQuery__
 *
 * To run a query within a React component, call `useInfohubGetChunkQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfohubGetChunkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfohubGetChunkQuery({
 *   variables: {
 *      chunkId: // value for 'chunkId'
 *   },
 * });
 */
export function useInfohubGetChunkQuery(baseOptions: Apollo.QueryHookOptions<InfohubGetChunkQuery, InfohubGetChunkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InfohubGetChunkQuery, InfohubGetChunkQueryVariables>(InfohubGetChunkDocument, options);
      }
export function useInfohubGetChunkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InfohubGetChunkQuery, InfohubGetChunkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InfohubGetChunkQuery, InfohubGetChunkQueryVariables>(InfohubGetChunkDocument, options);
        }
export type InfohubGetChunkQueryHookResult = ReturnType<typeof useInfohubGetChunkQuery>;
export type InfohubGetChunkLazyQueryHookResult = ReturnType<typeof useInfohubGetChunkLazyQuery>;
export type InfohubGetChunkQueryResult = Apollo.QueryResult<InfohubGetChunkQuery, InfohubGetChunkQueryVariables>;
export const InfohubUploadDocumentDocument = gql`
    mutation InfohubUploadDocument($file: Upload!, $metadata: String) {
  uploadDocument(input: {file: $file, metadata: $metadata}) {
    id
    filename
    originalFilename
    mimeType
    sizeInBytes
    storagePath
    status
    uploadedBy
    uploadedAt
    metadata
  }
}
    `;
export type InfohubUploadDocumentMutationFn = Apollo.MutationFunction<InfohubUploadDocumentMutation, InfohubUploadDocumentMutationVariables>;

/**
 * __useInfohubUploadDocumentMutation__
 *
 * To run a mutation, you first call `useInfohubUploadDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInfohubUploadDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [infohubUploadDocumentMutation, { data, loading, error }] = useInfohubUploadDocumentMutation({
 *   variables: {
 *      file: // value for 'file'
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function useInfohubUploadDocumentMutation(baseOptions?: Apollo.MutationHookOptions<InfohubUploadDocumentMutation, InfohubUploadDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InfohubUploadDocumentMutation, InfohubUploadDocumentMutationVariables>(InfohubUploadDocumentDocument, options);
      }
export type InfohubUploadDocumentMutationHookResult = ReturnType<typeof useInfohubUploadDocumentMutation>;
export type InfohubUploadDocumentMutationResult = Apollo.MutationResult<InfohubUploadDocumentMutation>;
export type InfohubUploadDocumentMutationOptions = Apollo.BaseMutationOptions<InfohubUploadDocumentMutation, InfohubUploadDocumentMutationVariables>;
export const InfohubDeleteDocumentDocument = gql`
    mutation InfohubDeleteDocument($id: String!) {
  deleteDocument(id: $id)
}
    `;
export type InfohubDeleteDocumentMutationFn = Apollo.MutationFunction<InfohubDeleteDocumentMutation, InfohubDeleteDocumentMutationVariables>;

/**
 * __useInfohubDeleteDocumentMutation__
 *
 * To run a mutation, you first call `useInfohubDeleteDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInfohubDeleteDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [infohubDeleteDocumentMutation, { data, loading, error }] = useInfohubDeleteDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInfohubDeleteDocumentMutation(baseOptions?: Apollo.MutationHookOptions<InfohubDeleteDocumentMutation, InfohubDeleteDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InfohubDeleteDocumentMutation, InfohubDeleteDocumentMutationVariables>(InfohubDeleteDocumentDocument, options);
      }
export type InfohubDeleteDocumentMutationHookResult = ReturnType<typeof useInfohubDeleteDocumentMutation>;
export type InfohubDeleteDocumentMutationResult = Apollo.MutationResult<InfohubDeleteDocumentMutation>;
export type InfohubDeleteDocumentMutationOptions = Apollo.BaseMutationOptions<InfohubDeleteDocumentMutation, InfohubDeleteDocumentMutationVariables>;
export const InfohubCreateSessionDocument = gql`
    mutation InfohubCreateSession($title: String) {
  createSession(input: {title: $title}) {
    id
    userId
    title
    messageCount
    createdAt
    lastMessageAt
    contextWindowTokens
  }
}
    `;
export type InfohubCreateSessionMutationFn = Apollo.MutationFunction<InfohubCreateSessionMutation, InfohubCreateSessionMutationVariables>;

/**
 * __useInfohubCreateSessionMutation__
 *
 * To run a mutation, you first call `useInfohubCreateSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInfohubCreateSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [infohubCreateSessionMutation, { data, loading, error }] = useInfohubCreateSessionMutation({
 *   variables: {
 *      title: // value for 'title'
 *   },
 * });
 */
export function useInfohubCreateSessionMutation(baseOptions?: Apollo.MutationHookOptions<InfohubCreateSessionMutation, InfohubCreateSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InfohubCreateSessionMutation, InfohubCreateSessionMutationVariables>(InfohubCreateSessionDocument, options);
      }
export type InfohubCreateSessionMutationHookResult = ReturnType<typeof useInfohubCreateSessionMutation>;
export type InfohubCreateSessionMutationResult = Apollo.MutationResult<InfohubCreateSessionMutation>;
export type InfohubCreateSessionMutationOptions = Apollo.BaseMutationOptions<InfohubCreateSessionMutation, InfohubCreateSessionMutationVariables>;
export const InfohubSendMessageDocument = gql`
    mutation InfohubSendMessage($sessionId: ID!, $content: String!) {
  sendMessage(input: {sessionId: $sessionId, content: $content}) {
    userMessage {
      id
      sessionId
      role
      content
      tokenCount
      sequenceNumber
      createdAt
      parentMessageId
    }
    assistantMessage {
      id
      sessionId
      role
      content
      tokenCount
      sequenceNumber
      createdAt
      parentMessageId
    }
  }
}
    `;
export type InfohubSendMessageMutationFn = Apollo.MutationFunction<InfohubSendMessageMutation, InfohubSendMessageMutationVariables>;

/**
 * __useInfohubSendMessageMutation__
 *
 * To run a mutation, you first call `useInfohubSendMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInfohubSendMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [infohubSendMessageMutation, { data, loading, error }] = useInfohubSendMessageMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useInfohubSendMessageMutation(baseOptions?: Apollo.MutationHookOptions<InfohubSendMessageMutation, InfohubSendMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InfohubSendMessageMutation, InfohubSendMessageMutationVariables>(InfohubSendMessageDocument, options);
      }
export type InfohubSendMessageMutationHookResult = ReturnType<typeof useInfohubSendMessageMutation>;
export type InfohubSendMessageMutationResult = Apollo.MutationResult<InfohubSendMessageMutation>;
export type InfohubSendMessageMutationOptions = Apollo.BaseMutationOptions<InfohubSendMessageMutation, InfohubSendMessageMutationVariables>;
export const InfohubGetMySessionsDocument = gql`
    query InfohubGetMySessions {
  mySessions {
    id
    userId
    title
    messageCount
    createdAt
    lastMessageAt
    contextWindowTokens
  }
}
    `;

/**
 * __useInfohubGetMySessionsQuery__
 *
 * To run a query within a React component, call `useInfohubGetMySessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfohubGetMySessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfohubGetMySessionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useInfohubGetMySessionsQuery(baseOptions?: Apollo.QueryHookOptions<InfohubGetMySessionsQuery, InfohubGetMySessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InfohubGetMySessionsQuery, InfohubGetMySessionsQueryVariables>(InfohubGetMySessionsDocument, options);
      }
export function useInfohubGetMySessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InfohubGetMySessionsQuery, InfohubGetMySessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InfohubGetMySessionsQuery, InfohubGetMySessionsQueryVariables>(InfohubGetMySessionsDocument, options);
        }
export type InfohubGetMySessionsQueryHookResult = ReturnType<typeof useInfohubGetMySessionsQuery>;
export type InfohubGetMySessionsLazyQueryHookResult = ReturnType<typeof useInfohubGetMySessionsLazyQuery>;
export type InfohubGetMySessionsQueryResult = Apollo.QueryResult<InfohubGetMySessionsQuery, InfohubGetMySessionsQueryVariables>;
export const InfohubGetSessionDocument = gql`
    query InfohubGetSession($sessionId: ID!) {
  session(sessionId: $sessionId) {
    id
    userId
    title
    messageCount
    createdAt
    lastMessageAt
    contextWindowTokens
  }
}
    `;

/**
 * __useInfohubGetSessionQuery__
 *
 * To run a query within a React component, call `useInfohubGetSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfohubGetSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfohubGetSessionQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useInfohubGetSessionQuery(baseOptions: Apollo.QueryHookOptions<InfohubGetSessionQuery, InfohubGetSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InfohubGetSessionQuery, InfohubGetSessionQueryVariables>(InfohubGetSessionDocument, options);
      }
export function useInfohubGetSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InfohubGetSessionQuery, InfohubGetSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InfohubGetSessionQuery, InfohubGetSessionQueryVariables>(InfohubGetSessionDocument, options);
        }
export type InfohubGetSessionQueryHookResult = ReturnType<typeof useInfohubGetSessionQuery>;
export type InfohubGetSessionLazyQueryHookResult = ReturnType<typeof useInfohubGetSessionLazyQuery>;
export type InfohubGetSessionQueryResult = Apollo.QueryResult<InfohubGetSessionQuery, InfohubGetSessionQueryVariables>;
export const InfohubGetSessionMessagesDocument = gql`
    query InfohubGetSessionMessages($sessionId: ID!) {
  messages(sessionId: $sessionId) {
    id
    sessionId
    role
    content
    tokenCount
    sequenceNumber
    createdAt
    parentMessageId
  }
}
    `;

/**
 * __useInfohubGetSessionMessagesQuery__
 *
 * To run a query within a React component, call `useInfohubGetSessionMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfohubGetSessionMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfohubGetSessionMessagesQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useInfohubGetSessionMessagesQuery(baseOptions: Apollo.QueryHookOptions<InfohubGetSessionMessagesQuery, InfohubGetSessionMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InfohubGetSessionMessagesQuery, InfohubGetSessionMessagesQueryVariables>(InfohubGetSessionMessagesDocument, options);
      }
export function useInfohubGetSessionMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InfohubGetSessionMessagesQuery, InfohubGetSessionMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InfohubGetSessionMessagesQuery, InfohubGetSessionMessagesQueryVariables>(InfohubGetSessionMessagesDocument, options);
        }
export type InfohubGetSessionMessagesQueryHookResult = ReturnType<typeof useInfohubGetSessionMessagesQuery>;
export type InfohubGetSessionMessagesLazyQueryHookResult = ReturnType<typeof useInfohubGetSessionMessagesLazyQuery>;
export type InfohubGetSessionMessagesQueryResult = Apollo.QueryResult<InfohubGetSessionMessagesQuery, InfohubGetSessionMessagesQueryVariables>;
export const InfohubDeleteSessionDocument = gql`
    mutation InfohubDeleteSession($sessionId: ID!) {
  deleteSession(sessionId: $sessionId)
}
    `;
export type InfohubDeleteSessionMutationFn = Apollo.MutationFunction<InfohubDeleteSessionMutation, InfohubDeleteSessionMutationVariables>;

/**
 * __useInfohubDeleteSessionMutation__
 *
 * To run a mutation, you first call `useInfohubDeleteSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInfohubDeleteSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [infohubDeleteSessionMutation, { data, loading, error }] = useInfohubDeleteSessionMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useInfohubDeleteSessionMutation(baseOptions?: Apollo.MutationHookOptions<InfohubDeleteSessionMutation, InfohubDeleteSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InfohubDeleteSessionMutation, InfohubDeleteSessionMutationVariables>(InfohubDeleteSessionDocument, options);
      }
export type InfohubDeleteSessionMutationHookResult = ReturnType<typeof useInfohubDeleteSessionMutation>;
export type InfohubDeleteSessionMutationResult = Apollo.MutationResult<InfohubDeleteSessionMutation>;
export type InfohubDeleteSessionMutationOptions = Apollo.BaseMutationOptions<InfohubDeleteSessionMutation, InfohubDeleteSessionMutationVariables>;
export const InfohubDeleteMessageDocument = gql`
    mutation InfohubDeleteMessage($sessionId: ID!, $messageId: ID!) {
  deleteMessage(sessionId: $sessionId, messageId: $messageId)
}
    `;
export type InfohubDeleteMessageMutationFn = Apollo.MutationFunction<InfohubDeleteMessageMutation, InfohubDeleteMessageMutationVariables>;

/**
 * __useInfohubDeleteMessageMutation__
 *
 * To run a mutation, you first call `useInfohubDeleteMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInfohubDeleteMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [infohubDeleteMessageMutation, { data, loading, error }] = useInfohubDeleteMessageMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      messageId: // value for 'messageId'
 *   },
 * });
 */
export function useInfohubDeleteMessageMutation(baseOptions?: Apollo.MutationHookOptions<InfohubDeleteMessageMutation, InfohubDeleteMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InfohubDeleteMessageMutation, InfohubDeleteMessageMutationVariables>(InfohubDeleteMessageDocument, options);
      }
export type InfohubDeleteMessageMutationHookResult = ReturnType<typeof useInfohubDeleteMessageMutation>;
export type InfohubDeleteMessageMutationResult = Apollo.MutationResult<InfohubDeleteMessageMutation>;
export type InfohubDeleteMessageMutationOptions = Apollo.BaseMutationOptions<InfohubDeleteMessageMutation, InfohubDeleteMessageMutationVariables>;
export const InfohubSubscribeExtractionStatusDocument = gql`
    subscription InfohubSubscribeExtractionStatus {
  extractionStatusUpdated {
    documentId
    documentFilename
    processingStatus
    totalChunks
    chunksWithEmbeddings
    completionPercentage
    extractedText
    textLength
    error
    startedAt
    completedAt
  }
}
    `;

/**
 * __useInfohubSubscribeExtractionStatusSubscription__
 *
 * To run a query within a React component, call `useInfohubSubscribeExtractionStatusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useInfohubSubscribeExtractionStatusSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfohubSubscribeExtractionStatusSubscription({
 *   variables: {
 *   },
 * });
 */
export function useInfohubSubscribeExtractionStatusSubscription(baseOptions?: Apollo.SubscriptionHookOptions<InfohubSubscribeExtractionStatusSubscription, InfohubSubscribeExtractionStatusSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<InfohubSubscribeExtractionStatusSubscription, InfohubSubscribeExtractionStatusSubscriptionVariables>(InfohubSubscribeExtractionStatusDocument, options);
      }
export type InfohubSubscribeExtractionStatusSubscriptionHookResult = ReturnType<typeof useInfohubSubscribeExtractionStatusSubscription>;
export type InfohubSubscribeExtractionStatusSubscriptionResult = Apollo.SubscriptionResult<InfohubSubscribeExtractionStatusSubscription>;
export const InfohubAdminSearchSessionsDocument = gql`
    query InfohubAdminSearchSessions($query: String, $userId: String, $startDate: String, $endDate: String, $first: Int, $after: String) {
  adminSearchSessions(
    filter: {query: $query, userId: $userId, startDate: $startDate, endDate: $endDate}
    pagination: {first: $first, after: $after}
  ) {
    edges {
      node {
        id
        userId
        title
        messageCount
        createdAt
        lastMessageAt
        contextWindowTokens
      }
      cursor
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;

/**
 * __useInfohubAdminSearchSessionsQuery__
 *
 * To run a query within a React component, call `useInfohubAdminSearchSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfohubAdminSearchSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfohubAdminSearchSessionsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      userId: // value for 'userId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useInfohubAdminSearchSessionsQuery(baseOptions?: Apollo.QueryHookOptions<InfohubAdminSearchSessionsQuery, InfohubAdminSearchSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InfohubAdminSearchSessionsQuery, InfohubAdminSearchSessionsQueryVariables>(InfohubAdminSearchSessionsDocument, options);
      }
export function useInfohubAdminSearchSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InfohubAdminSearchSessionsQuery, InfohubAdminSearchSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InfohubAdminSearchSessionsQuery, InfohubAdminSearchSessionsQueryVariables>(InfohubAdminSearchSessionsDocument, options);
        }
export type InfohubAdminSearchSessionsQueryHookResult = ReturnType<typeof useInfohubAdminSearchSessionsQuery>;
export type InfohubAdminSearchSessionsLazyQueryHookResult = ReturnType<typeof useInfohubAdminSearchSessionsLazyQuery>;
export type InfohubAdminSearchSessionsQueryResult = Apollo.QueryResult<InfohubAdminSearchSessionsQuery, InfohubAdminSearchSessionsQueryVariables>;
export const InfohubAdminSearchMessagesDocument = gql`
    query InfohubAdminSearchMessages($query: String, $userId: String, $role: String, $startDate: String, $endDate: String, $first: Int, $after: String) {
  adminSearchMessages(
    filter: {query: $query, userId: $userId, role: $role, startDate: $startDate, endDate: $endDate}
    pagination: {first: $first, after: $after}
  ) {
    edges {
      node {
        id
        sessionId
        role
        content
        tokenCount
        sequenceNumber
        createdAt
        parentMessageId
      }
      cursor
      sessionId
      sessionUserId
      sessionTitle
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;

/**
 * __useInfohubAdminSearchMessagesQuery__
 *
 * To run a query within a React component, call `useInfohubAdminSearchMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfohubAdminSearchMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfohubAdminSearchMessagesQuery({
 *   variables: {
 *      query: // value for 'query'
 *      userId: // value for 'userId'
 *      role: // value for 'role'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useInfohubAdminSearchMessagesQuery(baseOptions?: Apollo.QueryHookOptions<InfohubAdminSearchMessagesQuery, InfohubAdminSearchMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InfohubAdminSearchMessagesQuery, InfohubAdminSearchMessagesQueryVariables>(InfohubAdminSearchMessagesDocument, options);
      }
export function useInfohubAdminSearchMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InfohubAdminSearchMessagesQuery, InfohubAdminSearchMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InfohubAdminSearchMessagesQuery, InfohubAdminSearchMessagesQueryVariables>(InfohubAdminSearchMessagesDocument, options);
        }
export type InfohubAdminSearchMessagesQueryHookResult = ReturnType<typeof useInfohubAdminSearchMessagesQuery>;
export type InfohubAdminSearchMessagesLazyQueryHookResult = ReturnType<typeof useInfohubAdminSearchMessagesLazyQuery>;
export type InfohubAdminSearchMessagesQueryResult = Apollo.QueryResult<InfohubAdminSearchMessagesQuery, InfohubAdminSearchMessagesQueryVariables>;